import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from "reactstrap";
import { getNavIcon } from "./navIcons";

const NavbarVerticalMenuItem = ({ route }) => {
  const Icon = getNavIcon(route);

  return (
    <>
      <span className="hl-nav-icon" aria-hidden="true">
        {Icon ? (
          <Icon size={18} strokeWidth={1.75} />
        ) : (
          route.icon && <FontAwesomeIcon icon={route.icon} />
        )}
      </span>
      <span className="nav-link-text">{route.name}</span>
      {!!route.badge && (
        <Badge
          color={route.badge.color || "soft-success"}
          pill
          className="ml-2"
        >
          {route.badge.text}
        </Badge>
      )}
    </>
  );
};

export default React.memo(NavbarVerticalMenuItem);
